// extracted by mini-css-extract-plugin
export default {"hidden":"style_hidden__CDwSk","root":"style_root__4vFE7"};